import React, { useState } from 'react'
import styled from 'styled-components'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MoreVertIcon from '@mui/icons-material/MoreVert'

const Card = styled.div`
  display: flex;
  background: #fff;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
`

const TIER_COLOURS = {
  critical: '#e53935',
  medium:   '#f59f00',
  info:     '#9e9e9e',
}

const TierStrip = styled.div`
  width: 3px;
  background: ${({ $tier }) => TIER_COLOURS[$tier] || TIER_COLOURS.info};
  flex-shrink: 0;
`

const Body = styled.div`
  flex: 1;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.haiti};
`

const Subtitle = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey[200]};
`

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`

const PrimaryCta = styled.button`
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;

  &:hover { filter: brightness(0.95); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`

const RecommendationCard = ({ card, onCtaClick, onDismiss }) => {
  const [anchor, setAnchor] = useState(null)
  const open = Boolean(anchor)

  return (
    <Card>
      <TierStrip $tier={card.tier} />
      <Body>
        <Title>{card.title}</Title>
        <Subtitle>{card.subtitle}</Subtitle>
        <Row>
          <PrimaryCta onClick={() => onCtaClick(card)}>{card.ctaLabel}</PrimaryCta>
          <IconButton size="small" onClick={e => setAnchor(e.currentTarget)} aria-label="More options">
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <Menu anchorEl={anchor} open={open} onClose={() => setAnchor(null)}>
            <MenuItem onClick={() => { setAnchor(null); onCtaClick({ ...card, ctaKind: 'open_chat_with_question' }) }}>
              Open in chat
            </MenuItem>
            <MenuItem onClick={() => { setAnchor(null); onDismiss('snooze_30d') }}>
              Snooze for 30 days
            </MenuItem>
            <MenuItem onClick={() => { setAnchor(null); onDismiss('forever') }}>
              Don&apos;t show this again
            </MenuItem>
          </Menu>
        </Row>
      </Body>
    </Card>
  )
}

export default RecommendationCard
